import Header from "../layout/header";
import { useAppSelector } from "../../store/store";
import { Typography } from "@material-ui/core";
import { Box } from "@mui/material";

export default function Logout() {
  const { userData } = useAppSelector((state) => state.authReducer);

  return (
    <Box>
      <img
        src="assets/images/account-freezed-image.png"
        alt=""
        style={{
          height: "50%",
          width: "30%",
          minWidth: "400px",
          display: "block",
          margin: "0 auto",
        }}
      />
      <h2 style={{ textAlign: "center" }}>
        Your Account is Freezed, Please contact System Administrator for more
        details.
      </h2>
    </Box>
  );
}
